import React, { useState, useEffect, useRef } from 'react'
import { FaSearch } from "react-icons/fa";
import { MdAdd } from "react-icons/md";
import AdduserModal from './adduserModal';
import { RiCollapseDiagonalLine } from "react-icons/ri";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { TbReload } from "react-icons/tb";
import { TbArrowsSort } from "react-icons/tb";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import User from './users/user';

const PRODUCT_LIST = [
    
    "WhatsApp"
];

// Custom multi-select component
function ProductDropdownMultiSelect({ value, onChange }) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const wrapperRef = useRef(null);

    // Close dropdown if clicked outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Add or remove selected value
    function handleSelect(product) {
        if (value.includes(product)) {
            onChange(value.filter((p) => p !== product));
        } else {
            onChange([...value, product]);
        }
    }

    return (
        <div className="relative" ref={wrapperRef}>
            <div
                className="flex flex-wrap gap-2 bg-transparent border border-[#d4cfcf] rounded-md px-2 py-2 min-h-[39px] dark:bg-[#121519] dark:text-[#fff] items-center cursor-pointer"
                onClick={() => setDropdownOpen((open) => !open)}
                tabIndex={0}
            >
                {value.length === 0 && (
                    <span className="text-gray-400 text-xs">Select Products</span>
                )}
                {value.map((v) => (
                    <span
                        key={v}
                        className="flex items-center bg-[#37715d] text-white rounded px-2 py-[2px] text-xs font-semibold mr-1 cursor-default"
                    >
                        {v}
                        <MdClose
                            className="ml-1 text-sm cursor-pointer"
                            onClick={e => {
                                e.stopPropagation();
                                onChange(value.filter(x => x !== v));
                            }}
                        />
                    </span>
                ))}
                <span className="ml-auto">
                    {dropdownOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </span>
            </div>
            {dropdownOpen && (
                <div
                    className="absolute z-10 left-0 right-0 mt-1 bg-white dark:bg-[#1d1e20] border border-[#d4cfcf] rounded shadow-md max-h-[180px] overflow-y-auto"
                >
                    {PRODUCT_LIST.map(product => (
                        <div
                            key={product}
                            className={`flex items-center px-3 py-2 cursor-pointer hover:bg-[#f1f7fd] dark:hover:bg-[#232629] ${
                                value.includes(product) ? "bg-[#e4f8e0] dark:bg-[#264c36]" : ""
                            }`}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleSelect(product);
                            }}
                        >
                            <input
                                type="checkbox"
                                className="mr-2"
                                checked={value.includes(product)}
                                readOnly
                            />
                            <span className="text-xs">{product}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

function UserManagement() {
    const [open, setOpen] = useState(false);
    const [showpasword, setshowpasword] = useState(false);
    const [username, setusername] = useState('')
    const [MobileNumber, setMobileNumber] = useState('')
    const [EmailId, setEmailId] = useState('')
    const [AccountExpiryDate, setAccountExpiryDate] = useState('');
    const [password, setpassword] = useState('')
    const [AccountType, setAccountType] = useState('')
    const [SelectProducts, setSelectProducts] = useState([])
    const [showList, setShowList] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});
    const [userdetails, setuserdetail] = useState(false);
    const [userList, setuserList] = useState([]);
    const [activeTab, setActiveTab] = useState('All');
    // Get the token from localStorage
    const token = localStorage.getItem('token');

    // Initialize userId as null
    let userId = null;

    if (token) {
        try {
            const payload = token.split('.')[1];
            const payloadDecoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
            userId = payloadDecoded.userId || null;
        } catch (err) {
            console.error("Failed to decode token:", err);
        }
    }

    const users = userList;    
    let filteredUsers = users.filter(user =>
        (user?.userName || user?.name || '').toLowerCase().includes(username.toLowerCase())
    );

    const foundUser = users.find(
        (user) =>
            ((user?.userName || user?.name) || '').toLowerCase() === username.toLowerCase()
    );

    const [submitLoading, setSubmitLoading] = useState(false);

    const tabs = ['All', 'Users', 'Resellers', 'Managers', 'Agents'];

    const tabFilteredUsers = users.filter(user => {
        if (activeTab === 'All') return true;
        const type = (user?.accountType || '').toLowerCase();
        const tabMap = {
            'users': 'user',
            'resellers': 'reseller',
            'managers': 'manager',
            'agents': 'agent',
        };
        return type === (tabMap[activeTab.toLowerCase()] || '');
    });

filteredUsers = tabFilteredUsers.filter(user =>
    (user?.userName || user?.name || '').toLowerCase().includes(username.toLowerCase())
);

    useEffect(() => {
        fetch('https://wa-api.globebot.io/auth/client')
            .then(response => response.json())
            .then(data => {
                const filtered = data.filter(item => item.AssignedBy === userId);
                setuserList(filtered);
            })
            .catch(error => console.error('Error fetching user list:', error));
    }, [userId]);


    async function handlesubmit(e) {
        if (e) e.preventDefault();

        if (
            !username ||
            !password ||
            !MobileNumber ||
            !EmailId ||
            !AccountExpiryDate ||
            !AccountType ||
            SelectProducts.length === 0
        ) {
            alert("Please fill out all fields.");
            return;
        }

        setSubmitLoading(true);
        try {
            const payload = {
                AssignedBy:userId,
                Expiry:AccountExpiryDate,
                name:username,
                status:'Active',
                API_Key:"soon",
                Mobile:MobileNumber,
                password:password,
                email:EmailId,
                accountType: AccountType,
                products: SelectProducts
            };
            const response = await fetch('https://wa-api.globebot.io/auth/client', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { 'Authorization': `Bearer ${token}` })
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (response.ok && (data.success || data.status === 'success')) {
                alert("User created successfully!");
                setusername('');
                setpassword('');
                setMobileNumber('');
                setEmailId('');
                setAccountExpiryDate('');
                setAccountType('');
                setSelectProducts([]);
                setOpen(false);
                
            } else {
                alert((data && (data.message || data.error)) || "Failed to create user.");
            }
            window.location.reload();
        } catch (err) {
            alert("Failed to create user.");
            console.error(err);
        } finally {
            setSubmitLoading(false);
        }
    }

    return (
        <>
            <div className='dark:bg-[#121519] pt-[70px] min-h-screen px-2 '>
                <div className='border-b-[1px]  border-[#cfcdcd] pb-1  mx-2   '>
                    <h1 className='text-[#000] font-semibold text-[16px] dark:text-[#fff]'>Manage User</h1>
                </div>
                <div className='py-4 px-4 w-[100%] dark:bg-[#121519] border-b-[1px]  border-[#cfcdcd] hidden'>
                    <div className='w-[100%] flex flex-wrap gap-4'>
                        <div className='w-full sm:w-[48%] lg:w-[32%] flex flex-col gap-1'>
                            <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]' type="text"
                                value={username}
                                onChange={(e) => {
                                    setusername(e.target.value);
                                    setShowList(true)
                                }}
                            />
                        </div>

                        <div className='w-full sm:w-[48%] lg:w-[32%] flex items-center gap-1  justify-between'>
                            <button
                                onClick={() => {
                                    if (foundUser) {
                                        setSelectedUser(foundUser);
                                        setShowList(false);
                                        setusername('');
                                        setuserdetail(true)
                                    } else {
                                        setSelectedUser(null);
                                        alert("User not found");
                                    }
                                }}
                                className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto '>
                                <FaSearch />
                                <span className='text-[12px] font-bold'>
                                    Search</span>
                            </button>
                            <button
                                onClick={() => { setOpen(!open) }}
                                className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto '>
                                <MdAdd />
                                <span className='text-[12px] font-bold '> Add User</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className='py-4 px-4 w-full dark:bg-[#121519] border-b border-[#cfcdcd]'>
    <div className='w-full flex flex-wrap gap-4'>
        
        {/* Search with dropdown */}
        <div className='w-full sm:w-[48%] lg:w-[32%] flex flex-col gap-1 relative'>
            <div className='flex items-center border border-[#d4cfcf] rounded-md overflow-hidden dark:bg-[#121519]'>
                <input
                    className='flex-1 text-[#454546] text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
                    type="text"
                    placeholder='Search user...'
                    value={username}
                    onChange={(e) => {
                        setusername(e.target.value);
                        setShowList(true);
                        setuserdetail(false);
                    }}
                />
                <div className='px-2 text-gray-400'><FaSearch /></div>
            </div>

            {/* Dropdown suggestions */}
            {showList && username && filteredUsers.length > 0 && (
                <div className='absolute top-[38px] left-0 right-0 z-50 bg-white dark:bg-[#1d1e20] border border-[#d4cfcf] rounded-md shadow-lg max-h-[200px] overflow-y-auto'>
                    {filteredUsers.map((user, i) => (
                        <div
                            key={user.id || i}
                            className='flex items-center justify-between px-3 py-2 cursor-pointer hover:bg-[#f1f7fd] dark:hover:bg-[#232629] border-b border-[#f0f0f0] dark:border-[#2a2f35] last:border-0'
                            onClick={() => {
                                setSelectedUser(user);
                                setusername(user?.userName || user?.name || '');
                                setShowList(false);
                                setuserdetail(true);
                            }}
                        >
                            <div>
                                <p className='text-[12px] font-semibold dark:text-white text-[#333]'>
                                    {user?.userName || user?.name}
                                </p>
                                <p className='text-[10px] text-gray-400'>{user?.email || ''}</p>
                            </div>
                            <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border capitalize
                                ${(user?.accountType || '').toLowerCase() === 'reseller' ? 'bg-purple-100 text-purple-600 border-purple-200' :
                                  (user?.accountType || '').toLowerCase() === 'manager' ? 'bg-yellow-100 text-yellow-600 border-yellow-200' :
                                  (user?.accountType || '').toLowerCase() === 'agent' ? 'bg-blue-100 text-blue-600 border-blue-200' :
                                  'bg-green-100 text-green-600 border-green-200'}`}>
                                {user?.accountType || 'User'}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>

        {/* Add User button */}
        <div className='w-full sm:w-[48%] lg:w-[32%] flex items-center gap-1'>
            <button
                onClick={() => setOpen(!open)}
                className='flex items-center justify-center border border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-white w-full sm:w-auto transition-colors'
            >
                <MdAdd />
                <span className='text-[12px] font-bold'>Add User</span>
            </button>
        </div>
    </div>
</div>
{/* Tabs */}
<div className='flex gap-0 border-b border-[#cfcdcd] px-4 mt-3 overflow-x-auto'>
    {tabs.map(tab => (
        <button
            key={tab}
            onClick={() => { setActiveTab(tab); }}
            className={`px-4 py-2 text-[12px] font-semibold whitespace-nowrap border-b-2 transition-colors
                ${activeTab === tab
                    ? 'border-[#37715d] text-[#37715d]'
                    : 'border-transparent text-gray-400 hover:text-[#37715d]'
                }`}
        >
            {tab}
            <span className={`ml-1 text-[10px] px-1.5 py-0.5 rounded-full font-bold
                ${activeTab === tab ? 'bg-[#37715d] text-white' : 'bg-gray-100 text-gray-500'}`}>
                {tab === 'All'
                    ? users.length
                    : users.filter(u => (u?.accountType || '').toLowerCase() === tab.toLowerCase().slice(0, -1)).length}
            </span>
        </button>
    ))}
</div>
                <User username={username} setusername={setusername} filteredUsers={tabFilteredUsers} setShowList={setShowList} showList={showList} selectedUser={selectedUser} setSelectedUser={setSelectedUser} userdetails={userdetails} setuserdetail={setuserdetail} />
                <div className='w-[100%] h-[50px]'>
                </div>
                <AdduserModal isOpen={open} onClose={() => setOpen(false)} heading={'Create User'} >
                    <form
                        className=' py-1 px-4 w-[100%] dark:bg-[#121519]'
                        onSubmit={handlesubmit}
                        autoComplete="off"
                    >
                        <div className='w-[100%] flex flex-wrap gap-2'>
                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>UserName</label>
                                <input
                                    value={username}
                                    onChange={(e) => setusername(e.target.value)}
                                    placeholder='Enter User name'
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                />
                            </div>
                            <div className='w-full  flex  gap-1'>
                                <div className='flex flex-col w-[100%]'>
                                    <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Password</label>
                                    <div className='flex justify-between border-[#d4cfcf] border-[1px] rounded-md w-[100%] py-1'>
                                        <input
                                            value={password}
                                            onChange={(e) => setpassword(e.target.value)}
                                            placeholder='Enter Password'
                                            className='text-[#454546]  text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                            type={showpasword ? 'text' : 'password'}
                                        />
                                        <div className='border-l-[1px] border-[#d4cfcf] p-2 text-[#454546] '>
                                            {showpasword ? <FaEye onClick={() => { setshowpasword(!showpasword) }} /> : <FaEyeSlash onClick={() => { setshowpasword(!showpasword) }} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Mobile Number</label>
                                <input
                                    value={MobileNumber}
                                    onChange={(e) => {
                                        // Only allow numbers and limit to 12 digits
                                        const numericValue = e.target.value.replace(/\D/g, '').slice(0, 12);
                                        setMobileNumber(numericValue);
                                    }}
                                    placeholder='Enter Mobile Number'
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="tel"
                                    inputMode="numeric"
                                    pattern="[0-9]{0,12}"
                                    maxLength={12}
                                />
                            </div>
                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>EmailId</label>
                                <input
                                    value={EmailId}
                                    onChange={(e) => setEmailId(e.target.value)}
                                    placeholder='Enter Email Address'
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="text"
                                />
                            </div>
                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Account Expiry Date</label>
                                <input
                                    value={AccountExpiryDate}
                                    onChange={(e) => setAccountExpiryDate(e.target.value)}
                                    placeholder='Enter Expiry Date'
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]'
                                    type="date"
                                />
                            </div>
                            <div className='w-full  flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Account Type</label>
                                <select
                                    value={AccountType}
                                    onChange={(e) => setAccountType(e.target.value)}
                                    className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 dark:bg-[#121519] dark:text-[#fff]'
                                >
                                    <option value="">Select Account Type</option>
                                    <option value="Reseller">Reseller</option>
                                    <option value="User">User</option>
                                    <option value="Manager">Manager</option>
                                    <option value="Agent">Agent</option>
                                </select>
                            </div>
                            <div className='w-full flex flex-col gap-1'>
                                <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Select Products</label>
                                <ProductDropdownMultiSelect value={SelectProducts} onChange={setSelectProducts} />
                                <div className="text-xs text-gray-500 mt-1 dark:text-gray-400">
                                    Click to select one or more products. You can remove selected products by clicking the close icon.
                                </div>
                            </div>
                            <div className='w-full  flex items-center justify-end gap-1 mt-4'>
                                <button
                                    type="submit"
                                    disabled={submitLoading}
                                    className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2  gap-2 bg-[#37715d] text-[#fff] w-full sm:w-auto'
                                >
                                    <span className='text-[12px] font-bold'>
                                        {submitLoading ? 'Saving...' : 'Save'}
                                    </span>
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setOpen(!open)
                                    }}
                                    className='flex items-center justify-end border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'
                                >
                                    <span className='text-[12px] font-bold'>Close</span>
                                </button>
                            </div>
                        </div>
                    </form>
                </AdduserModal>
            </div>
        </>
    )
}

export default UserManagement
